import { InvoicePaymentStatus } from '@/services/billing';

export const statusFilterValues: Array<InvoicePaymentStatus> = ['succeeded', 'failed', 'pending'];

export default {};
